import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Route, RouterModule } from '@angular/router';
import { DashboardFeatureStorageLocationsSetupComponent } from '@luggagehero/dashboard-feature-storage-locations-setup';
import { DashboardFeatureTaxesComponent } from '@luggagehero/dashboard-taxes-feature-settings';
import { AuthGuard } from '@luggagehero/services';
import { ProductService } from '@luggagehero/services/storage-manager/product.service';
import { SharedShopsService } from '@luggagehero/shared/services/shops';
import { SharedStorageService } from '@luggagehero/shared/services/storage';
import { UiModule } from '@luggagehero/web/features/ui/ui.module';
import { TranslateModule } from '@ngx-translate/core';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { CodeInputModule } from 'angular-code-input';
import { QRCodeModule } from 'angularx-qrcode';
import { FileUploadModule } from 'ng2-file-upload';
import { ModalModule } from 'ngx-bootstrap/modal';

import {
  AcceptTermsOfServiceComponent,
  BookingsShopComponent,
  EditShopComponent,
  InStoreDisplayComponent,
  ManageShopsComponent,
  ReportTransactionsComponent,
  SHOP_MANAGER_COMPONENTS,
  ShopManagerComponent,
  StorageLocationBookingComponent,
  StorageLocationPricingComponent,
} from '../shop-manager/components';

const routes: Array<Route> = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'storage-locations/new', component: EditShopComponent, canActivate: [AuthGuard] },
  { path: 'storage-locations/:id', component: EditShopComponent, canActivate: [AuthGuard] },
  {
    path: 'storage-locations/:id/sections/:section',
    component: EditShopComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'storage-locations/:id/bookings',
    component: BookingsShopComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'storage-locations/:id/bookings/:bookingId',
    component: StorageLocationBookingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'storage-locations/:id/pricing',
    component: StorageLocationPricingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'storage-locations/:id/transactions',
    component: ReportTransactionsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'storage-locations/:id/in-store-display',
    component: InStoreDisplayComponent,
  },
  {
    path: 'storage-locations/:id/tax-settings',
    component: DashboardFeatureTaxesComponent,
    canActivate: [AuthGuard],
  },
  { path: 'storage-manager', redirectTo: 'dashboard' },
  { path: 'dashboard', component: ShopManagerComponent, canActivate: [AuthGuard] },
  { path: 'terms-of-service', component: AcceptTermsOfServiceComponent, canActivate: [AuthGuard] },
];

const legacyRoutes: Array<Route> = [
  { path: 'shop-manager', component: ShopManagerComponent, canActivate: [AuthGuard] },
  { path: 'shop-manager/shops/add', component: EditShopComponent, canActivate: [AuthGuard] },
  { path: 'shop-manager/shops/:id', component: EditShopComponent, canActivate: [AuthGuard] },
  { path: 'shop-manager/shops/:id/section/:section', component: EditShopComponent, canActivate: [AuthGuard] },
  { path: 'shop-manager/shops/:id/bookings', component: BookingsShopComponent, canActivate: [AuthGuard] },
  { path: 'shop-manager/shops/:id/transactions', component: ReportTransactionsComponent, canActivate: [AuthGuard] },
];

@NgModule({
  exports: [ManageShopsComponent, ShopManagerComponent],
  declarations: [...SHOP_MANAGER_COMPONENTS],
  schemas: [NO_ERRORS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild([...routes, ...legacyRoutes]),
    ReactiveFormsModule,
    FileUploadModule,
    UiModule,
    TranslateModule,
    ModalModule.forRoot(),
    GridModule,
    ExcelModule,
    DatePickerModule,
    CodeInputModule,
    QRCodeModule,
    DashboardFeatureTaxesComponent,
    DashboardFeatureStorageLocationsSetupComponent,
  ],
  providers: [SharedShopsService, ProductService, SharedStorageService, provideHttpClient(withInterceptorsFromDi())],
})
export class ShopManagerModule {}
